import { Container, Typography } from '@mui/material';

function WelcomeSite() {
  return (
    <div className="content">
      <Container>
        <Typography style={{marginTop: '50px'}} fontSize={30}>Willkommen bei adrp2go</Typography>
        <Typography style={{marginTop: '50px', fontWeight: "bold"}}>Benutzerverwaltung leicht gemacht</Typography>
        <Typography style={{marginTop: '10px'}}>
        Auf dieser Seite können Sie Ihre Mitarbeiter-Accounts ganz einfach selbst verwalten.<br/>
        Legen Sie neue Benutzer an, setzen Sie Passwörter zurück oder löschen Sie nicht mehr benötigte Accounts – alles an einem Ort, schnell und unkompliziert.
        </Typography>
      </Container>
    </div>
  );
}

export default WelcomeSite;
